<template>
  <div class="container">
    <div class="device-item" v-for="item in deviceData" :key="item.title">
      <div
        class="device-icon"
        :style="{ backgroundImage: `url(${item.icon})` }"
      ></div>
      <div class="device-info">
        <div class="name">{{ item.name }}</div>
        <div class="num">设备数：{{ item.device }}</div>
        <div class="num">在线率：{{ item.rate }}%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    deviceData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  padding: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .device-item {
    box-sizing: border-box;
    width: 185px;
    // height: 74px;
    padding: 12px;
    display: flex;
    align-content: flex-start;
    justify-content: flex-start;
    margin: 5px 10px;
    background: rgba(88, 145, 200, 0.15);
    border: 1px solid #5891c8;
    .device-icon {
      width: 27px;
      height: 27px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
    .device-info {
      flex: 1;
      margin-left: 10px;
      .name {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #7cb5ec;
        line-height: 28px;
        margin-bottom: 5px;
      }
      .num,
      .rate {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 22px;
      }
    }
  }
}
</style>
